import React from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import DropDown from "components/ui/controls/drop-down/drop-down";

const PointCrn = (props) => {
  const { resultRetraite, ClientConjoint } = props;
  const context = useContext(AppContext);
  const InitialAnneeAcquisition = () => {
    const dt = new Date();

    return dt.getFullYear() - 2;
  };

  return (
    <>
      {context.state["Carriere" + ClientConjoint].filter((Carriere) => Carriere.Nature === "Crn").length > 0 && (
        <>
          <div className="card">
            <div className="category-column">
              <label className="prise-en-charge-cell-label" style={{ marginBottom: 0 }}>
                CRN section B
              </label>
            </div>
            <div className="value-column">
              <TextField
                value={context.state["TableauPoints" + ClientConjoint].RetraiteCompCrnSectionB}
                onChange={(e) => {
                  context.handlePointRetraite(ClientConjoint, "RetraiteCompCrnSectionB", e);
                }}
                dataType="ufloat"
                format={{ thousands: " ", precision: 2, decimal: "," }}
                normal
              />
            </div>
            <div className="value-column">
              <DropDown
                value={context.state["TableauPoints" + ClientConjoint].AnneeFinCrnSectionB}
                onChange={(e) => {
                  context.handlePointRetraite(ClientConjoint, "AnneeFinCrnSectionB", e);
                  props.CalculRetraite();
                }}
                options={[
                  { value: InitialAnneeAcquisition(), label: InitialAnneeAcquisition() },
                  { value: InitialAnneeAcquisition() + 1, label: InitialAnneeAcquisition() + 1 },
                ]}
                normal
              />
            </div>
            <div className="value-column">
              <TextField
                value={resultRetraite?.InfosRetraite?.Crn?.General?.PointCalculeSectionB === undefined ? 0 : resultRetraite?.InfosRetraite?.Crn?.General?.PointCalculeSectionB}
                disabled={true}
                dataType="ufloat"
                format={{ thousands: " ", precision: 2, decimal: "," }}
                normal
              />
            </div>
          </div>
          <div className="card">
            <div className="category-column">
              <label className="prise-en-charge-cell-label" style={{ marginBottom: 0 }}>
                CRN section C
              </label>
            </div>
            <div className="value-column">
              <TextField
                value={context.state["TableauPoints" + ClientConjoint].RetraiteCompCrnSectionC}
                onChange={(e) => {
                  context.handlePointRetraite(ClientConjoint, "RetraiteCompCrnSectionC", e);
                }}
                dataType="ufloat"
                format={{ thousands: " ", precision: 2, decimal: "," }}
                normal
              />
            </div>
            <div className="value-column">
              <DropDown
                value={context.state["TableauPoints" + ClientConjoint].AnneeFinCrnSectionC}
                onChange={(e) => {
                  context.handlePointRetraite(ClientConjoint, "AnneeFinCrnSectionB", e);
                  props.CalculRetraite();
                }}
                options={[
                  { value: InitialAnneeAcquisition(), label: InitialAnneeAcquisition() },
                  { value: InitialAnneeAcquisition() + 1, label: InitialAnneeAcquisition() + 1 },
                ]}
                normal
              />
            </div>
            <div className="value-column">
              <TextField
                value={resultRetraite?.InfosRetraite?.Crn?.General?.PointCalculeSectionC === undefined ? 0 : resultRetraite?.InfosRetraite?.Crn?.General?.PointCalculeSectionC}
                disabled={true}
                dataType="ufloat"
                format={{ thousands: " ", precision: 2, decimal: "," }}
                normal
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default PointCrn;
